import { LanguageId } from '@/config.js';

export const Expressions = 
[{
  // languages
  Type: 'Language',
  Items: [{
    Name: 'English',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'English'
    },{
      LanguageId: LanguageId.French,
      Text: 'Anglais'
    }]
  },{
    Name: 'French',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'French'
    },{
      LanguageId: LanguageId.French,
      Text: 'Français'
    }]
  }]
},{

  // validation
  Type: 'Validation',
  Items: [{
    Name: 'EmailRequired',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Email is required'
    },{
      LanguageId: LanguageId.French,
      Text: 'E-mail est requis'
    }]
  },{
    Name: 'InvalidEmail',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Invalid email address'
    },{
      LanguageId: LanguageId.French,
      Text: 'Adresse courriel non valide'
    }]
  },{
    Name: 'FirstNameRequired',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'First name is required'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le prénom est requis'
    }]
  },{
    Name: 'KeyIdRequired',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Key # is required'
    },{
      LanguageId: LanguageId.French,
      Text: 'Numéro de clé est requis'
    }]
  },{
    Name: 'FirstNameMaxChars',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'First name cannot exceed {0} characters'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le prénom ne doit pas dépasser {0} caractères'
    }]
  },{
    Name: 'DisplayNameMaxChars',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Display Name name cannot exceed {0} characters'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le nom affiché ne doit pas dépasser {0} caractères'
    }]
  },{
    Name: 'NameRequired',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Name is required'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le nom est requis'
    }]
  },{
    Name: 'OrganizationRequired',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Organization is required'
    },{
      LanguageId: LanguageId.French,
      Text: 'L\'organisation est nécessaire'
    }]
  },{
    Name: 'NameMaxChars',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Name cannot exceed {0} characters'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le nom ne doit pas dépasser {0} caractères'
    }]
  },{
    Name: 'NameAlphNumeric',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Name must be aplhanumeric'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le nom doit être alphanumérique'
    }]
  },{
    Name: 'NameAlphSpaces',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Name can only contain letters and spaces'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le nom ne peut contenir que des lettres et des espaces'
    }]
  },{
    Name: 'ContactPhoneMaxChars',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Contact phone cannot exceed {0} characters'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le numéro de téléphone du contact ne doit pas dépasser {0} caractères'
    }]
  },{
    Name: 'LanguageRequired',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Language is required'
    },{
      LanguageId: LanguageId.French,
      Text: 'La langue est requise'
    }]
  },{
    Name: 'TitleRequired',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Title is required'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le titre est requis'
    }]
  },{
    Name: 'TitleMaxChars',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Title cannot exceed {0} characters'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le titre ne doit pas dépasser {0} caractères'
    }]
  },{
    Name: 'DescriptionMaxChars',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Description cannot exceed {0} characters'
    },{
      LanguageId: LanguageId.French,
      Text: 'La description ne doit pas dépasser {0} caractères'
    }]
  },{
    Name: 'KioskNameRequired',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Kiosk name is required'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le nom du kiosque est requise'
    }]
  },{
    Name: 'KioskNameMaxChars',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Kiosk name cannot exceed {0} characters'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le nom du kiosque ne doit pas dépasser {0} caractères'
    }]
  },{
    Name: 'Required',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Required'
    },{
      LanguageId: LanguageId.French,
      Text: 'Obligatoire'
    }]
  },{
    Name: 'PasswordMinChars',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Must be a minimum of {0} characters'
    },{
      LanguageId: LanguageId.French,
      Text: 'Doit compter au moins {0} caractères'
    }]
  },{
    Name: 'RoleRequired',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Role is required'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le rôle est requis'
    }]
  },{
    Name: 'ResidentRequired',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Resident is required'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le résident est requis'
    }]
  },{
    Name: 'KioskRequired',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Kiosk is required'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le kiosque est requis'
    }]
  },{
    Name: 'FacilityRequired',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Facility is required'
    },{
      LanguageId: LanguageId.French,
      Text: 'L\'nstallation est requis'
    }]
  },{
    Name: 'DomainRequired',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Domain is required'
    },{
      LanguageId: LanguageId.French,
      Text: 'Domaine est requis'
    }]
  },{
    Name: 'MessageTextRequired',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Message text is required'
    },{
      LanguageId: LanguageId.French,
      Text: 'Texte du message est requis'
    }]
  },{
    Name: 'EmailMessageRequired',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Email message is required'
    },{
      LanguageId: LanguageId.French,
      Text: 'Un message courriel est requis'
    }]
  }]
},{

  // functional roles
  Type: 'FunctionalRole',
  Items: [{
    Name: 'Admin',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Admin'
    },{
      LanguageId: LanguageId.French,
      Text: 'Administrateur'
    }]
  },{
    Name: 'DomainManager',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Domain Manager'
    },{
      LanguageId: LanguageId.French,
      Text: 'Gestionnaire de domaine'
    }]
  },{
    Name: 'KioskManager',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Kiosk Manager'
    },{
      LanguageId: LanguageId.French,
      Text: 'Gestionnaire'
    }]
  },{
    Name: 'FamilyFacilitator',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Family Facilitator'
    },{
      LanguageId: LanguageId.French,
      Text: 'Facilitateur familial'
    }]
  },{
    Name: 'VirtualVisitor',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Virtual Visitor'
    },{
      LanguageId: LanguageId.French,
      Text: 'Visiteur virtuel'
    }]
  }]
},{

  // buttons
  Type: 'Button', 
  Items: [{
    Name: 'Save',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Save'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sauvegarder'
    }]
  },{
    Name: 'Cancel',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Cancel'
    },{
      LanguageId: LanguageId.French,
      Text: 'Annuler'
    }]
  },{
    Name: 'OK',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'OK'
    },{
      LanguageId: LanguageId.French,
      Text: 'D\'ACCORD'
    }]
  },{
    Name: 'KioskPlaylists',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Community Playlists'
    },{
      LanguageId: LanguageId.French,
      Text: 'Playlists publiques'
    }]
  },{
    Name: 'AllUsers',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'All Users'
    },{
      LanguageId: LanguageId.French,
      Text: 'Tous les utilisateurs'
    }]
  },{
    Name: 'KioskEmails',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'GENIEGRAMs'
    },{
      LanguageId: LanguageId.French,
      Text: 'GENIEGRAMs'
    }]
  },{
    Name: 'EditKiosk',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Edit Kiosk'
    },{
      LanguageId: LanguageId.French,
      Text: 'Modifier le kiosque'
    }]
  },{
    Name: 'AddResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add Resident',
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter un résident',
    }]
  },{
    Name: 'SendMessage',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Send Message',
    },{
      LanguageId: LanguageId.French,
      Text: 'Envoyer le message',
    }]
  },{
    Name: 'Send',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Send',
    },{
      LanguageId: LanguageId.French,
      Text: 'Envoyer',
    }]
  },{
    Name: 'CommunityPlaylists',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Community Playlists'
    },{
      LanguageId: LanguageId.French,
      Text: 'Playlists publiques'
    }]
  },{
    Name: 'KioskLibrary',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Kiosk Library'
    },{
      LanguageId: LanguageId.French,
      Text: 'Bibliothèque'
    }]
  },{
    Name: 'AllMessages',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'All Messages'
    },{
      LanguageId: LanguageId.French,
      Text: 'Tous les messages'
    }]
  },{
    Name: 'Messages',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Messages'
    },{
      LanguageId: LanguageId.French,
      Text: 'Messages'
    }]
  },{
    Name: 'Users',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Users'
    },{
      LanguageId: LanguageId.French,
      Text: 'Utilisateurs'
    }]
  },{
    Name: 'Contacts',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Contacts'
    },{
      LanguageId: LanguageId.French,
      Text: 'Contacts'
    }]
  },{
    Name: 'Facilitators',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Facilitators'
    },{
      LanguageId: LanguageId.French,
      Text: 'Facilitateurs'
    }]
  },{
    Name: 'MemoryAlbums',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Memory Albums'
    },{
      LanguageId: LanguageId.French,
      Text: 'Albums souvenir'
    }]
  },{
    Name: 'Library',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Library'
    },{
      LanguageId: LanguageId.French,
      Text: 'Bibliothèque'
    }]
  },{
    Name: 'Folder',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Folder'
    },{
      LanguageId: LanguageId.French,
      Text: 'Dossier'
    }]
  },{
    Name: 'SelectLibrary',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Select library'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sélectionnez la bibliothèque'
    }]
  },{
    Name: 'SelectFolder',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Select folder'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sélectionner le dossier'
    }]
  },{
    Name: 'Metrics',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Metrics'
    },{
      LanguageId: LanguageId.French,
      Text: 'Métrologie'
    }]
  },{
    Name: 'EditContent',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Edit Content'
    },{
      LanguageId: LanguageId.French,
      Text: 'Modifier le contenu'
    }]
  },{
    Name: 'AddContent',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add Content'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter du contenu'
    }]
  },{
    Name: 'CreatePlaylist',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Create Playlist'
    },{
      LanguageId: LanguageId.French,
      Text: 'Créer une playlist'
    }]
  },{
    Name: 'CreateAlbum',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Create Album'
    },{
      LanguageId: LanguageId.French,
      Text: 'Créer un album'
    }]
  },{
    Name: 'CreateEmail',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Create Email'
    },{
      LanguageId: LanguageId.French,
      Text: 'Créer un courriel'
    }]
  },{
    Name: 'Detail',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Detail'
    },{
      LanguageId: LanguageId.French,
      Text: 'Détails'
    }]
  },{
    Name: 'Close',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Close'
    },{
      LanguageId: LanguageId.French,
      Text: 'Fermer'
    }]
  },{
    Name: 'EditResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Edit Resident'
    },{
      LanguageId: LanguageId.French,
      Text: 'Modifier le résident'
    }]
  },{
    Name: 'AddContact',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add Contact'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter un contact'
    }]
  },{
    Name: 'AddFamilyFacilitator',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add Facilitator'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter facilitateur'
    }]
  },{
    Name: 'AddMedia',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add Media'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter des médias'
    }]
  },{
    Name: 'ChangePicture',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Change Picture'
    },{
      LanguageId: LanguageId.French,
      Text: 'Changer l\'image'
    }]
  },{
    Name: 'AddPicture',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add Picture'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter une image'
    }]
  },{
    Name: 'SaveChanges',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Save Changes'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sauvegarder'
    }]
  },{
    Name: 'DeleteResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Delete This Resident'
    },{
      LanguageId: LanguageId.French,
      Text: 'Supprimer ce résident'
    }]
  },{
    Name: 'ResidentPlaylists',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Resident Playlists'
    },{
      LanguageId: LanguageId.French,
      Text: 'Playlists du résident'
    }]
  },{
    Name: 'Yes',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Yes'
    },{
      LanguageId: LanguageId.French,
      Text: 'Oui'
    }]
  },{
    Name: 'No',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'No'
    },{
      LanguageId: LanguageId.French,
      Text: 'Non'
    }]      
  },{
    Name: 'AddImage',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add Image'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter une image'
    }]
  },{
    Name: 'AddVideo',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add Video'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter une vidéo'
    }]
  },{
    Name: 'AddAudio',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add Audio'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter Audio'
    }]
  },{
    Name: 'Upload',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Upload'
    },{
      LanguageId: LanguageId.French,
      Text: 'Téléverser'
    }]
  },{
    Name: 'ResendInvitation',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Resend Invitation'
    },{
      LanguageId: LanguageId.French,
      Text: 'Renvoyer l\'invitation'
    }]
  },{
    Name: 'Select',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Select'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sélectionner'
    }]
  },{
    Name: 'CreateGeniegram',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Create Geniegram'
    },{
      LanguageId: LanguageId.French,
      Text: 'Créer Geniegram'
    }]
  }]
},{

  // headings
  Type: 'Heading',
  Items: [{
    Name: 'KioskFunction',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Select a kiosk <b>function</b> to manage',
      Short: 'Select <b>function</b>'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sélectionner une <b>fonction</b> kiosque à gérer',
      Short: 'Sélectionner <b>fonction</b>'
    }]
  },{
    Name: 'ResidentFunction',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Select a <b>resident</b> to access their dashboard',
      Short: 'Select <b>resident</b>'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sélectionner un <b>résident</b> pour accéder à son tableau de bord',
      Short: 'Sélectionner <b>résident</b>'
    }]
  },{
    Name: 'SelectManagedKiosk',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Select one of your {0} <b>managed</b> kiosks',
      Short: 'Select <b>kiosk</b>'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sélectionner l\'un des {0} kiosques <b>gérés</b>',
      Short: 'Sélectionner <b>kiosk</b>'
    }]
  },{
    Name: 'SelectManagedResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Select one of your {0} <b>managed</b> residents',
      Short: 'Select <b>resident</b>'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sélectionner l\'un des {0} résidents <b>gérés</b>',
      Short: 'Sélectionner <b>résident</b>'
    }]
  },{
    Name: 'ManageResidentExperience',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Manage this <b>resident\'s</b> experience',
      Short: 'Manage <b>resident</b>'
    },{
      LanguageId: LanguageId.French,
      Text: 'Gérer l\'expérience de ce <b>résident</b>',
      Short: 'Gérer <b>résident</b>'
    }]
  },{
    Name: 'EmailDetail',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'GENIEGRAM Detail'
    },{
      LanguageId: LanguageId.French,
      Text: 'Détails de GENIEGRAM'
    }]
  },{
    Name: 'GenieUsage',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Genie Usage'
    },{
      LanguageId: LanguageId.French,
      Text: 'Usage de Genie'
    }]
  },{
    Name: 'MetricsMessages',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Messages'
    },{
      LanguageId: LanguageId.French,
      Text: 'Messages'
    }]
  },{
    Name: 'MetricsMemoryAlbums',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Memory Albums'
    },{
      LanguageId: LanguageId.French,
      Text: 'Albums souvenir'
    }]
  },{
    Name: 'ManageKiosk',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Manage Kiosk'
    },{
      LanguageId: LanguageId.French,
      Text: 'Gérer le kiosque'
    }]
  },{
    Name: 'MessageCenter',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Message Center'
    },{
      LanguageId: LanguageId.French,
      Text: 'Centre de messagerie'
    }]
  },{
    Name: 'ManageResidentsAndContacts',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Manage Residents and Contacts',
      Short: 'Residents and Contacts'
    },{
      LanguageId: LanguageId.French,
      Text: 'Gérer les résidents et les contacts',
      Short: 'Les résidents et les contacts'
    }]
  },{
    Name: 'ManageResidentsAndFamilyFacilitators',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Manage Residents and Family Facilitators',
      Short: 'Residents and Family Facilitators'
    },{
      LanguageId: LanguageId.French,
      Text: 'Gérer les résidents et facilitateurs familialiaux',
      Short: 'Résidents et facilitateurs familialiaux'
    }]
  },{
    Name: 'AllResidents',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'All Residents'
    },{
      LanguageId: LanguageId.French,
      Text: 'Tous les résidents'
    }]
  }]
},{

  // dashboard links
  Type: 'DashboardLink',
  Items: [{
    Name: 'SendMessageToResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Send Message To Residents',
      Short: 'Send Message'
    },{
      LanguageId: LanguageId.French,
      Text: 'Envoyer un message aux résidents',
      Short: 'Envoyer un message'
    }]
  },{
    Name: 'Send',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Send'
    },{
      LanguageId: LanguageId.French,
      Text: 'Envoyer'
    }]
  },{
    Name: 'ToResidentContacts',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'To Residents\' Contacts',
      Short: ''
    },{
      LanguageId: LanguageId.French,
      Text: 'aux contacts des résidents',
      Short: ''
    }]
  },{
    Name: 'AddResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add Resident'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter un résident'
    }]
  },{
    Name: 'ManageAllMessages',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Manage All Messages',
      Short: 'Manage Messages'
    },{
      LanguageId: LanguageId.French,
      Text: 'Gérer tous les messages',
      Short: 'Gérer les messages'
    }]
  },{
    Name: 'AllPlatformParticipants',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Manage Platform Participants',
      Short: 'Platform Participants'
    },{
      LanguageId: LanguageId.French,
      Text: 'Gérer les participants de la plateforme',
      Short: 'Participants de la plateforme'
    }]
  },{
    Name: 'AllKioskManagers',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Manage Kiosk Managers'
    },{
      LanguageId: LanguageId.French,
      Text: 'Gérer les gestionnaires de kiosque'
    }]
  },{
    Name: 'AllResidentContacts',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Manage Contacts'
    },{
      LanguageId: LanguageId.French,
      Text: 'Gérer les contacts'
    }]
  },{
    Name: 'AddResidentContact',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add Contact'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter un contact',
      Short: 'Utilisateurs'
    }]
  },{
    Name: 'AddFamilyFacilitator',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add Family Facilitator',
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter un facilitateur familial',
    }]
  },{
    Name: 'CommunityPlaylists',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Community Playlists'
    },{
      LanguageId: LanguageId.French,
      Text: 'Playlists publiques'
    }]
  },{
    Name: 'KioskLibrary',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Kiosk Library',
    },{
      LanguageId: LanguageId.French,
      Text: 'Bibliothèque',
    }]
  },{
    Name: 'AddKioskManager',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add Kiosk Manager'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter un gestionnaire de kiosque'
    }]
  }]
},{

  // dashboard info text
  Type: 'DashboardInfo',
  Items: [{
    Name: 'SendMessageToResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Send messages to one or multiple residents.',
    },{
      LanguageId: LanguageId.French,
      Text: 'Envoyez des messages à un ou plusieurs résidents.',
    }]
  },{
    Name: 'SendGeniegramToResidentContacts',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Send email messages to all of a Resident\'s contacts.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Envoyez des e-mails à tous les contacts d\'un résident.'
    }]
  },{
    Name: 'AddResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Create and onboard a Resident.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Créez et intégrez un résident.'
    }]
  },{
    Name: 'ManageAllMessages',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Monitor and delete Messages sent to and from a Resident.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Surveiller et supprimer les messages envoyés vers et depuis un résident.'
    }]
  },{
    Name: 'AllPlatformParticipants',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Manage Platform Participants'
    },{
      LanguageId: LanguageId.French,
      Text: 'Tous les participants de la plateforme'
    }]
  },{
    Name: 'AllKioskManagers',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Edit and delete Kiosk Managers on the platform.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Modifiez et supprimez les gestionnaires de kiosque sur la plate-forme.'
    }]
  },{
    Name: 'AllResidentContacts',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Edit and delete Resident Contacts.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Modifier et supprimer les contacts résidents.'
    }]
  },{
    Name: 'AddResidentContact',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Create a Contact, assign Contact role and assign to a Resident.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Créer un contact, attribuer un rôle de contact et attribuer à un résident.'
    }]
  },{
    Name: 'AddFamilyFacilitator',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Create a Family Facilitator and assign to a Resident.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Créez un facilitateur familial et affectez-le à un résident.'
    }]
  },{
    Name: 'KioskLibrary',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'A repository of media used to build Community Playlsts.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Un référentiel de médias utilisé pour créer des playlists communautaires.'
    }]
  },{
    Name: 'CommunityPlaylists',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Create and assign media playlists to be viewed by the community at large.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Créez et attribuez des listes de lecture multimédia à visionner par la communauté dans son ensemble.'
    }]
  },{
    Name: 'AddKioskManager',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Create and onboard a Kiosk Manager to the platform.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter un gestionnaire de kiosque'
    }]
  }]
},{

  // labels
  Type: 'Label',
  Items: [{
    Name: 'Name',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Name'
    },{
      LanguageId: LanguageId.French,
      Text: 'Nom'
    },]
  },{
    Name: 'DisplayName',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Display Name'
    },{
      LanguageId: LanguageId.French,
      Text: 'Nom affiché'
    }]
  },{
    Name: 'FirstName',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'First Name'
    },{
      LanguageId: LanguageId.French,
      Text: 'Prénom'
    }]
  },{
    Name: 'LastName',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Last Name'
    },{
      LanguageId: LanguageId.French,
      Text: 'Nom de famille'
    }]
  },{
    Name: 'Description',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Description'
    },{
      LanguageId: LanguageId.French,
      Text: 'Description'
    }]
  },{
    Name: 'Media',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Media'
    },{
      LanguageId: LanguageId.French,
      Text: 'Médias'
    }]
  },{
    Name: 'Active',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Active'
    },{
      LanguageId: LanguageId.French,
      Text: 'Actif'
    }]
  },{
    Name: 'AddedBy',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Added By'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouté par'
    }]
  },{
    Name: 'Status',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Status'
    },{
      LanguageId: LanguageId.French,
      Text: 'Statut'
    }]
  },{
    Name: 'Source',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Source'
    },{
      LanguageId: LanguageId.French,
      Text: 'La source'
    }]
  },{
    Name: 'Size',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Size'
    },{
      LanguageId: LanguageId.French,
      Text: 'Taille'
    }]
  },{
    Name: 'Duration',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Duration'
    },{
      LanguageId: LanguageId.French,
      Text: 'Durée'
    }]
  },{
    Name: 'Activate',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Activate'
    },{
      LanguageId: LanguageId.French,
      Text: 'Activer'
    }]
  },{
    Name: 'Content',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Content'
    },{
      LanguageId: LanguageId.French,
      Text: 'Contenu'
    }]
  },{
    Name: 'Title',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Title'
    },{
      LanguageId: LanguageId.French,
      Text: 'Titre'
    }]
  },{
    Name: 'Behaviour',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Behaviour'
    },{
      LanguageId: LanguageId.French,
      Text: 'Comportement'
    }]
  },{
    Name: 'Preview',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Preview'
    },{
      LanguageId: LanguageId.French,
      Text: 'Aperçu'
    }]
  },{
    Name: 'Owner',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Owner'
    },{
      LanguageId: LanguageId.French,
      Text: 'Propriétaire'
    }]
  },{
    Name: 'LastViewed',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Last Viewed'
    },{
      LanguageId: LanguageId.French,
      Text: 'Dernière consultation'
    }]
  },{
    Name: 'CommunityPlaylilst',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Community Playlilst'
    },{
      LanguageId: LanguageId.French,
      Text: 'Playlist publique'
    }]
  },{
    Name: 'MemoryAlbum',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Memory Album'
    },{
      LanguageId: LanguageId.French,
      Text: 'Album souvenir'
    }]
  },{
    Name: 'Organization',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Organization'
    },{
      LanguageId: LanguageId.French,
      Text: 'Organisation'
    }]
  },{
    Name: 'Playlist',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Playlist'
    },{
      LanguageId: LanguageId.French,
      Text: 'Playlist'
    }]
  },{
    Name: 'Search',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Search'
    },{
      LanguageId: LanguageId.French,
      Text: 'Rechercher'
    }]
  },{
    Name: 'KeyId',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Key #'
    },{
      LanguageId: LanguageId.French,
      Text: 'N<sup>o</sup> de clé'
    }]
  },{
    Name: 'None',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'None'
    },{
      LanguageId: LanguageId.French,
      Text: 'aucun'
    }]
  },{
    Name: 'NoneAssigned',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'None assigned'
    },{
      LanguageId: LanguageId.French,
      Text: 'aucun attribué'
    }]
  },{
    Name: 'BeaconId',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Beacon ID'
    },{
      LanguageId: LanguageId.French,
      Text: 'ID de balise'
    }]
  },{
    Name: 'NumberOfResidents',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Number of residents:'
    },{
      LanguageId: LanguageId.French,
      Text: 'Nombre de résidents:'
    }]
  },{
    Name: 'ResidentsThatHaveNeverActivated',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'that have never keyed in'
    },{
      LanguageId: LanguageId.French,
      Text: 'qui ne se sont jamais connectés'
    }]
  },{
    Name: 'ResidentsThatHaventActivatedIn2Weeks',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'that haven\'t checked Genie in 2 weeks'
    },{
      LanguageId: LanguageId.French,
      Text: 'qui n\'ont pas vérifié Genie depuis 2 semaines'
    }]
  },{
    Name: 'NewMessages',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'New Messages'
    },{
      LanguageId: LanguageId.French,
      Text: 'Nouveaux messages'
    }]
  },{
    Name: 'LastMessageReceived',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Last Message Received'
    },{
      LanguageId: LanguageId.French,
      Text: 'Dernier message reçu'
    }]
  },{
    Name: 'LastMessageSent',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Last Message Sent'
    },{
      LanguageId: LanguageId.French,
      Text: 'Dernier message envoyé'
    }]
  },{
    Name: 'UserCount',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Number of Users'
    },{
      LanguageId: LanguageId.French,
      Text: 'Nombre d\'utilisateurs'
    }]
  },{
    Name: 'LastActivation',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Last Key In'
    },{
      LanguageId: LanguageId.French,
      Text: 'Dernière touche entrée'
    }]
  },{
    Name: 'DaysSinceLastActivation',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Days Since Last Key In'
    },{
      LanguageId: LanguageId.French,
      Text: 'Jours depuis la dernière saisie'
    }]
  },{
    Name: 'ResidentsWithNewMessages',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'with unread messages'
    },{
      LanguageId: LanguageId.French,
      Text: 'Avec de nouveaux messages'
    }]
  },{
    Name: 'ResidentsWithoutAMessageIn2Weeks',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'without a new message in 2 weeks'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sans message depuis 2 semaines'
    }]
  },{
    Name: 'ResidentsThatHaveNeverReceivedAMessage',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'that have never received a message'
    },{
      LanguageId: LanguageId.French,
      Text: 'qui n\'ont jamais reçu de message'
    }]
  },{
    Name: 'ResidentsWithoutUsers',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'without any users'
    },{
      LanguageId: LanguageId.French,
      Text: 'sans utilisateurs'
    }]
  },{
    Name: 'ResidentsWithoutAnFF',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'without a family facilitator'
    },{
      LanguageId: LanguageId.French,
      Text: 'sans facilitateur familial'
    }]
  },{
    Name: 'ResidentsWithoutMemoryAlbumAddition',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'without a memory album addition'
    },{
      LanguageId: LanguageId.French,
      Text: 'sans album souvenir'
    }]
  },{
    Name: 'ResidentsWithoutMemoryAlbumAdditionIn2Weeks',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'without an addition for 2 weeks'
    },{
      LanguageId: LanguageId.French,
      Text: 'Résidents sans album souvenir'
    }]
  },{
    Name: 'LastPlaylistUpload',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'last memory album addition'
    },{
      LanguageId: LanguageId.French,
      Text: 'Téléchargement de l\'album du dernier souvenir'
    }]
  },{
    Name: 'RowsPerPage',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Rows per page'
    },{
      LanguageId: LanguageId.French,
      Text: 'Lignes par page'
    }]
  },{
    Name: 'Cover',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Cover'
    },{
      LanguageId: LanguageId.French,
      Text: 'Couverture'
    }]
  },{
    Name: 'SlideShow',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Slide Show'
    },{
      LanguageId: LanguageId.French,
      Text: 'Diaporama'
    }]
  },{
    Name: 'Kiosk',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Kiosk'
    },{
      LanguageId: LanguageId.French,
      Text: 'Kiosque'
    }]
  },{
    Name: 'Resident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Resident'
    },{
      LanguageId: LanguageId.French,
      Text: 'Résident'
    }]
  },{
    Name: 'User',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'User'
    },{
      LanguageId: LanguageId.French,
      Text: 'Utilisateur'
    }]
  },{
    Name: 'Users',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Users'
    },{
      LanguageId: LanguageId.French,
      Text: 'Utilisateurs'
    }]
  },{
    Name: 'Sent',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Sent'
    },{
      LanguageId: LanguageId.French,
      Text: 'Envoyé'
    }]
  },{
    Name: 'Opened',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Opened'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ouvert'
    }]
  },{
    Name: 'Sender',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Sender'
    },{
      LanguageId: LanguageId.French,
      Text: 'Expéditeur'
    }]
  },{
    Name: 'Message',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Message'
    },{
      LanguageId: LanguageId.French,
      Text: 'Message'
    }]
  },{
    Name: 'Direction',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Direction'
    },{
      LanguageId: LanguageId.French,
      Text: 'Direction'
    }]
  },{
    Name: 'From',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'From'
    },{
      LanguageId: LanguageId.French,
      Text: 'De'
    }]
  },{
    Name: 'To',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'To'
    },{
      LanguageId: LanguageId.French,
      Text: 'À'
    }]
  },{
    Name: 'UserToResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Contact To Resident'
    },{
      LanguageId: LanguageId.French,
      Text: 'Contact vers résident'
    }]
  },{
    Name: 'ResidentToUser',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Resident To Contact'
    },{
      LanguageId: LanguageId.French,
      Text: 'Résident vers contact'
    }]
  },{
    Name: 'ToResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'To Resident'
    },{
      LanguageId: LanguageId.French,
      Text: 'Au résident'
    }]
  },{
    Name: 'ToUser',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'To User'
    },{
      LanguageId: LanguageId.French,
      Text: 'À l\'utilisateur'
    }]
  },{
    Name: 'Subject',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Subject'
    },{
      LanguageId: LanguageId.French,
      Text: 'Objet'
    }]
  },{
    Name: 'Type',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Type'
    },{
      LanguageId: LanguageId.French,
      Text: 'Type'
    }]
  },{
    Name: 'SelectKiosk',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Select Kiosk'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sélectionner le kiosque'
    }]
  },{
    Name: 'SelectResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Select Resident'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sélectionner le résident'
    }]
  },{
    Name: 'Email',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Email'
    },{
      LanguageId: LanguageId.French,
      Text: 'Email'
    }]
  },{
    Name: 'Language',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Language'
    },{
      LanguageId: LanguageId.French,
      Text: 'Langue'
    }]
  },{
    Name: 'KioskLanguage',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Kiosk Language'
    },{
      LanguageId: LanguageId.French,
      Text: 'Langue du kiosque'
    }]
  },{
    Name: 'Role',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Role'
    },{
      LanguageId: LanguageId.French,
      Text: 'Rôle'
    }]
  },{
    Name: 'Facilities',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Facilities'
    },{
      LanguageId: LanguageId.French,
      Text: 'Installations'
    }]
  },{
    Name: 'AssignedFacilities',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Assigned Facilities'
    },{
      LanguageId: LanguageId.French,
      Text: 'Installations attribuées'
    }]
  },{
    Name: 'AssignedFacility',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Assigned Facility'
    },{
      LanguageId: LanguageId.French,
      Text: 'Installation attribuée'
    }]
  },{
    Name: 'Domains',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Domains'
    },{
      LanguageId: LanguageId.French,
      Text: 'Domaines'
    }]
  },{
    Name: 'AssignedDomains',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Assigned Domains'
    },{
      LanguageId: LanguageId.French,
      Text: 'Domaines attribuées'
    }]
  },{
    Name: 'AssignedDomain',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Assigned Domain'
    },{
      LanguageId: LanguageId.French,
      Text: 'Domaine attribuée'
    }]
  },{
    Name: 'Kiosks',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Kiosks'
    },{
      LanguageId: LanguageId.French,
      Text: 'Kiosques'
    }]
  },{
    Name: 'AssignedKiosks',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Assigned Kiosks'
    },{
      LanguageId: LanguageId.French,
      Text: 'Kiosques attribuées'
    }]
  },{
    Name: 'Residents',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Residents'
    },{
      LanguageId: LanguageId.French,
      Text: 'Résidents'
    }]
  },{
    Name: 'AssignedResidents',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Assigned Residents'
    },{
      LanguageId: LanguageId.French,
      Text: 'Résidents attribués'
    }]
  },{
    Name: 'ConnectedResidents',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Connected Residents'
    },{
      LanguageId: LanguageId.French,
      Text: 'Résidents connectés'
    }]
  },{
    Name: 'DefaultResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Default Resident'
    },{
      LanguageId: LanguageId.French,
      Text: 'Résident par défaut'
    }]
  },{
    Name: 'LastLogin',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Last Login'
    },{
      LanguageId: LanguageId.French,
      Text: 'Dernière connexion'
    }]
  },{
    Name: 'KioskContact',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Kiosk Contact'
    },{
      LanguageId: LanguageId.French,
      Text: 'Contact du kiosque'
    }]
  },{
    Name: 'ContactName',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Contact Name'
    },{
      LanguageId: LanguageId.French,
      Text: 'Nom de la personne-ressource'
    }]
  },{
    Name: 'ContactPhone',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Contact Phone'
    },{
      LanguageId: LanguageId.French,
      Text: 'Numéro de la personne-ressource'
    }]
  },{
    Name: 'ContactPosition',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Contact Position'
    },{
      LanguageId: LanguageId.French,
      Text: 'Poste de la personne-ressource'
    }]
  },{
    Name: 'ContactAvailability',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Contact Availability'
    },{
      LanguageId: LanguageId.French,
      Text: 'Disponibilité'
    }]
  },{
    Name: 'ContentType',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Content Type'
    },{
      LanguageId: LanguageId.French,
      Text: 'Type de contenu'
    }]
  },{
    Name: 'Ready',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Ready'
    },{
      LanguageId: LanguageId.French,
      Text: 'Prêt'
    }]
  },{
    Name: 'MissingMedia',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Missing required media'
    },{
      LanguageId: LanguageId.French,
      Text: 'Média requis manquant'
    }]
  },{
    Name: 'Basic',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Basic'
    },{
      LanguageId: LanguageId.French,
      Text: 'De base'
    }]
  },{
    Name: 'Advanced',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Advanced'
    },{
      LanguageId: LanguageId.French,
      Text: 'Avancé'
    }]
  },{
    Name: 'Unlimited',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Unlimited'
    },{
      LanguageId: LanguageId.French,
      Text: 'Illimité'
    }]
  },{
    Name: 'AmbientAccess',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Ambient Access'
    },{
      LanguageId: LanguageId.French,
      Text: 'Accès Ambient'
    }]
  },{
    Name: 'AmbientBehaviour',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Ambient Behaviour'
    },{
      LanguageId: LanguageId.French,
      Text: 'Comportement Ambient'
    }]
  },{
    Name: 'CommunityPlaylist',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Community Playlist'
    },{
      LanguageId: LanguageId.French,
      Text: 'Playlist publique'
    }]
  },{
    Name: 'All',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'All'
    },{
      LanguageId: LanguageId.French,
      Text: 'Tout'
    }]
  },{
    Name: 'NewPassword',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'New Password'
    },{
      LanguageId: LanguageId.French,
      Text: 'Nouveau mot de passe'
    }]
  },{
    Name: 'Standard',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Standard'
    },{
      LanguageId: LanguageId.French,
      Text: 'Standard'
    }]
  },{
    Name: 'Announcement',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Announcement'
    },{
      LanguageId: LanguageId.French,
      Text: 'Annonce'
    }]
  },{
    Name: 'Old',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Old'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ancien'
    }]
  },{
    Name: 'New',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'New'
    },{
      LanguageId: LanguageId.French,
      Text: 'Nouveaux'
    }]
  },{
    Name: 'Last',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Last'
    },{
      LanguageId: LanguageId.French,
      Text: 'Dernier'
    }]
  },{
    Name: 'Count',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Count'
    },{
      LanguageId: LanguageId.French,
      Text: 'Nombre'
    }]
  },{
    Name: 'Home',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Home'
    },{
      LanguageId: LanguageId.French,
      Text: 'Accueil'
    }]
  },{
    Name: 'ChangeSelection',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Change Selection'
    },{
      LanguageId: LanguageId.French,
      Text: 'Modifier la playlist'
    }]
  },{
    Name: 'MakeFamilyFacilitator',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Give this contact <i>Family Facilitator</i> priveleges'
    },{
      LanguageId: LanguageId.French,
      Text: 'Donner à cet contact les privilèges de <i>facilitateur familial</i>'
    }]
  },{
    Name: 'AddOptionalResidentContact',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add a contact (optional)'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter un contact (facultatif)'
    }]
  },{
    Name: 'AddOptionalFamilyFacilitator',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add a family facilitator (optional)'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter un facilitateur familial (facultatif)'
    }]
  },{
    Name: 'KioskType',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Kiosk Type'
    },{
      LanguageId: LanguageId.French,
      Text: 'Type de kiosque'
    }]
  },{
    Name: 'Success',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Success'
    },{
      LanguageId: LanguageId.French,
      Text: 'Succès'
    }]
  },{
    Name: 'Error',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Error'
    },{
      LanguageId: LanguageId.French,
      Text: 'Erreur'
    }]
  },{
    Name: 'Attachments',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Attachments'
    },{
      LanguageId: LanguageId.French,
      Text: 'Pièces jointes'
    }]
  },{
    Name: 'XAttachments',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '{0} attachments'
    },{
      LanguageId: LanguageId.French,
      Text: '{0} pièces jointes'
    }]
  },{
    Name: '1Attachment',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '1 attachment'
    },{
      LanguageId: LanguageId.French,
      Text: '1 pièce jointe'
    }]
  },{
    Name: 'Detail',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Detail'
    },{
      LanguageId: LanguageId.French,
      Text: 'Détail'
    }]
  },{
    Name: 'Recipient',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Recipient'
    },{
      LanguageId: LanguageId.French,
      Text: 'Destinataire'
    }]
  },{
    Name: 'Recipients',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Recipients'
    },{
      LanguageId: LanguageId.French,
      Text: 'Destinataires'
    }]
  },{
    Name: 'Created',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Created'
    },{
      LanguageId: LanguageId.French,
      Text: 'Établie'
    }]
  },{
    Name: 'NumFiles',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '# Files'
    },{
      LanguageId: LanguageId.French,
      Text: '# Dossiers'
    }]
  },{
    Name: 'Files',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Files'
    },{
      LanguageId: LanguageId.French,
      Text: 'Dossiers'
    }]
  },{
    Name: 'New',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'New'
    },{
      LanguageId: LanguageId.French,
      Text: 'Nouveau'
    }]
  },{
    Name: 'Today',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Today'
    },{
      LanguageId: LanguageId.French,
      Text: 'Aujourd\'hui'
    }]
  },{
    Name: 'Added',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Added'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouté'
    }]
  },{
    Name: 'ForPeriod',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'For Period'
    },{
      LanguageId: LanguageId.French,
      Text: 'Période'
    }]
  },{
    Name: 'Kiosk',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Kiosk'
    },{
      LanguageId: LanguageId.French,
      Text: 'Kiosque'
    },]
  },{
    Name: 'Facility',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Facility'
    },{
      LanguageId: LanguageId.French,
      Text: 'Installation'
    },]
  },{
    Name: 'MessagesReceivedByResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'messages received by {0}'
    },{
      LanguageId: LanguageId.French,
      Text: 'message reçu par {0}'
    },]
  },{
    Name: 'MessagesSentByResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'messages sent by {0}'
    },{
      LanguageId: LanguageId.French,
      Text: 'message expédié par {0}'
    },]
  },{
    Name: 'GenieAccesses',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Genie accesses'
    },{
      LanguageId: LanguageId.French,
      Text: 'accès Genie'
    }]
  },{
    Name: 'LibraryUploads',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'library uploads'
    },{
      LanguageId: LanguageId.French,
      Text: 'téléchargement à la bibliothèque'
    }]
  },{
    Name: 'NoContact',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'No contact'
    },{
      LanguageId: LanguageId.French,
      Text: 'Pas de contact'
    }]      
  },{
    Name: 'Library',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Library'
    },{
      LanguageId: LanguageId.French,
      Text: 'Bibliothèque'
    }]      
  },{
    Name: 'SelectLibrary',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Select library'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sélectionnez la bibliothèque'
    }]
  },{
    Name: 'SelectFolder',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Select folder'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sélectionner le dossier'
    }]
  }]
},{

  // form titles
  Type: 'FormTitle',
  Items: [{
    Name: 'NewPlaylist',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'New Playlist'
    },{
      LanguageId: LanguageId.French,
      Text: 'Nouvelle playlist'
    }]
  },{
    Name: 'EditPlaylist',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Edit Playlist'
    },{
      LanguageId: LanguageId.French,
      Text: 'Modifier la playlist'
    }]
  },{
    Name: 'NewAlbum',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'New Album'
    },{
      LanguageId: LanguageId.French,
      Text: 'Nouvel album'
    }]
  },{
    Name: 'EditAlbum',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Edit Album'
    },{
      LanguageId: LanguageId.French,
      Text: 'Modifier l\'album'
    }]
  },{
    Name: 'CreateEmail',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Create Email'
    },{
      LanguageId: LanguageId.French,
      Text: 'Créer Courriel'
    }]
  },{
    Name: 'AddResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add Resident'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter le résident'
    }]
  },{
    Name: 'EditKiosk',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Edit Kiosk'
    },{
      LanguageId: LanguageId.French,
      Text: 'Modifier le kiosque'
    }]
  },{
    Name: 'EditResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Edit Resident'
    },{
      LanguageId: LanguageId.French,
      Text: 'Modifier le résident'
    }]
  },{
    Name: 'EditUser',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Edit User'
    },{
      LanguageId: LanguageId.French,
      Text: 'Modifier l\'utilisateur'
    }]
  },{
    Name: 'AddUser',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add User'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter l\'utilisateur'
    }]
  },{
    Name: 'EditContact',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Edit Contact'
    },{
      LanguageId: LanguageId.French,
      Text: 'Modifier contact'
    }]
  },{
    Name: 'EditFamilyFacilitator',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Edit Family Facilitator'
    },{
      LanguageId: LanguageId.French,
      Text: 'Modifier facilitateur familial'
    }]
  },{
    Name: 'AddContact',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add Contact'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter contact'
    }]
  },{
    Name: 'AddFamilyFacilitator',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add Family Facilitator'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter un facilitateur familial'
    }]
  },{
    Name: 'EditKioskManager',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Edit Kiosk Manager'
    },{
      LanguageId: LanguageId.French,
      Text: 'Modifier gestionnaire de kiosque'
    }]
  },{
    Name: 'AddKioskManager',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add Kiosk Manager'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter gestionnaire de kiosque'
    }]
  },{
    Name: 'CreateUser',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Create User'
    },{
      LanguageId: LanguageId.French,
      Text: 'Créer l\'utilisateur'
    }]
  },{
    Name: 'YourProfile',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Your Profile'
    },{
      LanguageId: LanguageId.French,
      Text: 'Votre profil'
    }]
  },{
    Name: 'DeleteMessage',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Delete Message?'
    },{
      LanguageId: LanguageId.French,
      Text: 'Supprimer le message?'
    }]
  },{
    Name: 'DeleteMedia',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Delete Media?' 
    },{
      LanguageId: LanguageId.French,
      Text: 'Supprimer le média?'
    }]
  },{
    Name: 'RemovePlaylistItems',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Remove Items?' 
    },{
      LanguageId: LanguageId.French,
      Text: 'Supprimer des éléments?'
    }]
  },{
    Name: 'DeleteUser',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Delete User?'
    },{
      LanguageId: LanguageId.French,
      Text: 'Supprimer l\'utilisateur?'
    }]
  },{
    Name: 'RemoveUser',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Remove User?'
    },{
      LanguageId: LanguageId.French,
      Text: 'Supprimer l\'utilisateur?'
    }]
  },{
    Name: 'DeletePlaylist',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Delete Playlist?'
    },{
      LanguageId: LanguageId.French,
      Text: 'Supprimer la playlist?'
    }]
  },{
    Name: 'DeleteMemoryAlbum',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Delete Memory Album?'
    },{
      LanguageId: LanguageId.French,
      Text: 'Supprimer cet album souvenir?'
    }]
  },{
    Name: 'DeleteItems',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Delete Item(s)?'
    },{
      LanguageId: LanguageId.French,
      Text: 'Supprimer les élément(s)?'
    }]
  },{
    Name: 'DeleteCommunityPlaylist',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Delete Community Playlist?'
    },{
      LanguageId: LanguageId.French,
      Text: 'Supprimer la playlist publique?'
    }]
  },{
    Name: 'MediaProperties',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Media Properties'
    },{
      LanguageId: LanguageId.French,
      Text: 'Propriétés médias'
    }]
  },{
    Name: 'SelectContentType',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '{0} Type' 
    },{
      LanguageId: LanguageId.French,
      Text: 'Type de {0}'
    }]
  },{
    Name: 'PlaylistPreview',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Playlist Preview' 
    },{
      LanguageId: LanguageId.French,
      Text: 'Aperçu de la playlist'
    }]
  },{
    Name: 'ResidentDashboard',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Resident Dashboard' 
    },{
      LanguageId: LanguageId.French,
      Text: 'Tableau de bord du résident'
    }]
  },{
    Name: 'GenieResidentMetrics',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Genie Resident Metrics' 
    },{
      LanguageId: LanguageId.French,
      Text: 'Métrologie Genie des résidents'
    }]
  },{
    Name: 'AbbyResidentMetrics',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Abby Resident Metrics' 
    },{
      LanguageId: LanguageId.French,
      Text: 'Métrologie Abby des résidents'
    }]
  },{
    Name: 'MobileAppUsers',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Family/Friends' 
    },{
      LanguageId: LanguageId.French,
      Text: 'Utilisateurs d\'apps mobiles'
    }]
  },{
    Name: 'RecentActivations',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Genie Accesses' 
    },{
      LanguageId: LanguageId.French,
      Text: 'Activations récentes'
    }]
  },{
    Name: 'MessagesTo',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Messages To'
    },{
      LanguageId: LanguageId.French,
      Text: 'Messages à'
    }]
  },{
    Name: 'MessagesFrom',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Messages From'
    },{
      LanguageId: LanguageId.French,
      Text: 'Messages de'
    }]
  },{
    Name: 'Playlists',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Playlists' 
    },{
      LanguageId: LanguageId.French,
      Text: 'Playlists'
    }]
  },{
    Name: 'MediaUploads',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Library Uploads' 
    },{
      LanguageId: LanguageId.French,
      Text: 'Téléchargements'
    }]
  },{
    Name: 'InternalError',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Internal Error' 
    },{
      LanguageId: LanguageId.French,
      Text: 'Erreur interne'
    }]
  },{
    Name: 'FileSizeExceeded',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'File Size Limit Exceeded' 
    },{
      LanguageId: LanguageId.French,
      Text: 'Limite du volume de fichier dépassée'
    }]
  },{
    Name: 'ProfileUpdateFailed',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Profile Update Failed' 
    },{
      LanguageId: LanguageId.French,
      Text: 'Échec de la mise à jour du profil'
    }]
  },{
    Name: 'ValidationFailed',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Validation Failed' 
    },{
      LanguageId: LanguageId.French,
      Text: 'Validation échouée'
    }]
  },{
    Name: 'InvalidMedia',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Invalid Media' 
    },{
      LanguageId: LanguageId.French,
      Text: 'Média non valide'
    }]
  },{
    Name: 'InspectionFailed',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Inspection Failed' 
    },{
      LanguageId: LanguageId.French,
      Text: 'Échec de l\'inspection'
    }]
  },{
    Name: 'ChangePassword',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Change Password'
    },{
      LanguageId: LanguageId.French,
      Text: 'Changer mot de passe'
    }]
  },{
    Name: 'AccessDenied',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Access Denied'
    },{
      LanguageId: LanguageId.French,
      Text: 'Accès refusé'
    }]
  },{
    Name: 'DeleteThisResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Delete this resident?'
    },{
      LanguageId: LanguageId.French,
      Text: 'Supprimer ce résident?'
    }]
  },{
    Name: 'ContactConnected',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Contact Connected'
    },{
      LanguageId: LanguageId.French,
      Text: 'Contact branché'
    }]
  },{
    Name: 'ManagerCreated',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Manager Created'
    },{
      LanguageId: LanguageId.French,
      Text: 'Gestionnaire créé'
    }]
  },{
    Name: 'MemoryAlbums',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Memory Albums'
    },{
      LanguageId: LanguageId.French,
      Text: 'Albums souvenir'
    }]
  },{
    Name: 'ActionNotPermitted',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Action Not Permitted'
    },{
      LanguageId: LanguageId.French,
      Text: 'Action non autorisée'
    }]
  },{
    Name: 'SelectPlaylist',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Select Playlist'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sélectionnez playlist'
    }]
  },{
    Name: 'CreateMessage',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Create Message'
    },{
      LanguageId: LanguageId.French,
      Text: 'Créer un message'
    }]
  },{
    Name: 'CreateEmail',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Create Email'
    },{
      LanguageId: LanguageId.French,
      Text: 'Créer Courriel'
    }]
  },{
    Name: 'MessageType',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Message Type'
    },{
      LanguageId: LanguageId.French,
      Text: 'Type de message'
    }]
  },{
    Name: 'SelectResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Select Resident(s)'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sélectionner résident(s)'
    }]
  },{
    Name: 'MessagesReceivedByUser',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Received by {0}'
    },{
      LanguageId: LanguageId.French,
      Text: 'Reçu par {0}'
    }]
  },{
    Name: 'MessagesSentByUser',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Sent by {0}'
    },{
      LanguageId: LanguageId.French,
      Text: 'Expédié par {0}'
    }]
  },{
    Name: 'MessagesReceivedFrom',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '{0} received from'
    },{
      LanguageId: LanguageId.French,
      Text: '{0} reçu de'
    }]
  },{
    Name: 'MessagesReceivedByType',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '{0} received by type'
    },{
      LanguageId: LanguageId.French,
      Text: '{0} a reçu selon le type'
    }]
  },{
    Name: 'MessagesSentTo',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '{0} sent to'
    },{
      LanguageId: LanguageId.French,
      Text: '{0} expédié à'
    }]
  },{
    Name: 'NewGeniegram',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'New GENIEGRAM'
    },{
      LanguageId: LanguageId.French,
      Text: 'Nouvel GENIEGRAM'
    }]
  },{
    Name: 'SelectCoverImage',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Select Cover Image'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sélectionner l\'image de couverture'
    }]
  },{
    Name: 'VideoConversionInProgress',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Conversion In Progress...'
    },{
      LanguageId: LanguageId.French,
      Text: 'Conversion en cours...'
    }]
  }]
},{

  // alerts
  Type: 'Alert',
  Items: [{
    Name: 'NoResidents',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Your kiosk has <b>no residents</b> yet.  To create your first resident click the <b>ADD RESIDENT</b> button.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Votre kiosque n\'a <b>aucun résident</b> pour le moment. Pour créer votre premier résident, cliquer sur le bouton <b>AJOUTER LE RÉSIDENT</b>.'
    }]
  },{
    Name: 'ActivePlaylistGenie',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'You are editing the content of the active community playlist. Changes here will have an immediate effect on your Genie.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Vous modifiez le contenu de la playlist communautaire active. Les changements apportés ici auront un effet immédiat sur votre Genie.'
    }]
  },{
    Name: 'ActivePlaylistAbby',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'You are editing the content of the active community playlist. Changes here will have an immediate effect on your Abby.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Vous modifiez le contenu de la playlist publique active. Les changements apportés ici auront un effet immédiat sur votre Abby.'
    }]
  },{
    Name: 'ActiveKioskPlaylistRule',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'The active kiosk playlist must contain at least 1 media item per <i>Media Type</i>.'
    },{
      LanguageId: LanguageId.French,
      Text: 'La liste de lecture active du kiosque doit contenir au moins 1 élément multimédia par <i>type de média</i>.'
    }]
  },{
    Name: 'NoContactsAssigned',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'The resident {0} has not been assigned to any contacts yet.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le résident {0} n\'a pas encore été affecté à aucun contact.'
    }]
  },{
    Name: 'NoFacilitatorsAssigned',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'The resident {0} has not been assigned to any facilitators yet.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le résident {0} n\'a pas encore été affecté à aucun facilitateur.'
    }]
  },{
    Name: 'ConnectContactToResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '<b>Connect</b> {0} with a new <b>Contact</b>.'
    },{
      LanguageId: LanguageId.French,
      Text: '<b>Connecter</b> {0} à un nouveau <b>contact</b>.'
    }]
  },{
    Name: 'ConnectFFToResident',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '<b>Connect</b> {0} with a new <b>Familiy Facilitator</b>.'
    },{
      LanguageId: LanguageId.French,
      Text: '<b>Connecter</b> {0} à un nouveau <b>facilitateur familial</b>.'
    }]
  },{
    Name: 'AddAndConnectContactToSelectedResidents',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '<b>Connect Residents</b> with a new <b>Contact</b>.'
    },{
      LanguageId: LanguageId.French,
      Text: '<b>Connecter les résidents</b> avec un nouveau <b>contact</b>.'
    }]
  },{
    Name: 'AddAndConnectFamilyFacilitator',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '<b>Connect Residents</b> with a new <b>Family Faciliator</b>.'
    },{
      LanguageId: LanguageId.French,
      Text: '<b>Connecter les résidents</b> avec un nouveau <b>animateur familial/b>.'
    }]
  },{
    Name: 'ContactAddConfirmation1',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'This contact has been sent a <b>confirmation email</b> and will be required to create a password to complete registration.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Cet contact a reçu un <b>e-mail de confirmation</b> et devra créer un mot de passe pour terminer l\'inscription.'
    }]
  },{
    Name: 'ContactAddConfirmation2',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'A <b>{0}</b> must download the mobile app <b>Ambient Connect</b>.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Un <b>{0}</b> doit télécharger l\'application mobile <b>Ambient Connect</b>.'
    }]
  },{
    Name: 'ContactAddConfirmation3',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Success!</br></br>A user with the email <b>{0}</b> is now connected with the selected resident(s).'
    },{
      LanguageId: LanguageId.French,
      Text: 'Succès!</br></br>Un utilisateur avec l\'email <b>{0}</b> est désormais connecté au(x) résident(s) sélectionné(s)..'
    }]
  },{
    Name: 'ConfirmationEmail',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Once the contact has been created they will receive a <b>confirmation email</b>.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Une fois le contact créé, il recevra un <b>courriel de confirmation</b>.'
    }]
  },{
    Name: 'AddKioskManager',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Add a <b>{0}</b> for this kiosk.</p>'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ajouter un <b>{0}</b> pour ce kiosque.'
    }]
  },{
    Name: 'DeleteMediaWarning',
    Items: [{
      LanguageId: LanguageId.English,
      Text: `You have <b>{0}</b> item(s) selected.</br></br>
        Items removed from here are <b>permanently</b> deleted.</br>`
    },{
      LanguageId: LanguageId.French,
      Text: `Vous avez <b>{0}</b> élément(s) sélectionnés.</br></br>
        Les éléments supprimés d'ici sont <b>définitivement</b> supprimés.</br>`
    }]
  },{
    Name: 'RemovePlaylistItemsWarning',
    Items: [{
      LanguageId: LanguageId.English,
      Text: `You have <b>{0}</b> item(s) selected.</br></br>
      Items removed from here are not permanently deleted and <b>can be accessed again</b> later.</br>`
    },{
      LanguageId: LanguageId.French,
      Text: `Les élément(s) retirés d'ici ne sont pas définitivement supprimés et <b>peuvent être consultés à nouveau</b> ultérieurement.</br>`
    }]
  },{
    Name: 'NotSelectableForDeletion',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Some items in this list are <b>not selectable</b> for deletion because they are currently <b>tied to a user message</b>.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Certains éléments de cette liste ne peuvent pas être <b> sélectionnés</b> pour les supprimer, car ils sont actuellement <b>liés à un message utilisateur</b>.'
    }]
  },{
    Name: 'SelectAbbyPlaylistText',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Select the playlist you would like to edit the content of.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sélectionnez la playlist dont vous souhaitez modifier le contenu.'
    }]
  },{
    Name: 'XItemsSelected',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'You have <b>{0}</b> item(s) selected.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Vous avez sélectionné<b>{0}</b> élément(s).'
    }]
  },{
    Name: 'PlaylistPreviewDescription',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Your <i>Announcements</i> (highlighted in yellow) will get feathered into the playlist as shown below.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Vos <i>annonces</i> (surlignées en jaune) seront intégrées à la playlist tel qu\'indiqué ci-dessous.'
    }]
  },{
    Name: 'MessageResidentSelectionText',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '<b>Select</b> which resident(s) will <b>receive</b> this message.'
    },{
      LanguageId: LanguageId.French,
      Text: '<b>Sélectionner le(s) résident(s) qui recevra(ont) ce message.'
    }]
  },{
    Name: 'GeniegramResidentSelectionText',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '<b>Select</b> which <b>resident(s)</b> this <b>GENIEGRAM</b> pertains to.'
    },{
      LanguageId: LanguageId.French,
      Text: '</b>Sélectionnez</b> à quel(s) <b>résident(s)</b> ce <b>GENIEGRAM</b> se rapporte.'
    }]
  },{
    Name: 'OneMoment',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'One moment...'
    },{
      LanguageId: LanguageId.French,
      Text: 'Un instant...'
    }]
  },{
    Name: 'LoadingItems',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Loading items...'
    },{
      LanguageId: LanguageId.French,
      Text: 'Chargement d\'éléments en cours...'
    }]
  },{
    Name: 'NoPreviewItems',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'No preview items found'
    },{
      LanguageId: LanguageId.French,
      Text: 'Aucun élément d\'aperçu trouvé'
    }]
  },{
    Name: 'NoMedia',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'No media found'
    },{
      LanguageId: LanguageId.French,
      Text: 'Aucun média trouvé'
    }]
  },{
    Name: 'NoMediaContainers',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'No media containers found'
    },{
      LanguageId: LanguageId.French,
      Text: 'Aucun répertoire média trouvé'
    }]
  },{
    Name: 'NoPlaylists',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'No playlists found'
    },{
      LanguageId: LanguageId.French,
      Text: 'Aucune playlist trouvée'
    }]
  },{
    Name: 'NoDomains',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'No domains found'
    },{
      LanguageId: LanguageId.French,
      Text: 'Aucun domaine trouvé'
    }]
  },{
    Name: 'NoKiosksOrResidents',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'You have no Abby kiosks or residents'
    },{
      LanguageId: LanguageId.French,
      Text: 'Vous n\'avez aucun kiosque ni de résident Abby'
    }]
  },{
    Name: 'NoProfileData',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'You have no Abby kiosks or residents'
    },{
      LanguageId: LanguageId.French,
      Text: 'Vous n\'avez aucun kiosque ni de résident Abby'
    }]
  },{
    Name: 'NoAbbyKiosks',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'You have no Abby kiosks'
    },{
      LanguageId: LanguageId.French,
      Text: 'Vous n\'avez aucun kiosque Abby'
    }]
  },{
    Name: 'NoKioskSelected',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'No kiosk selected'
    },{
      LanguageId: LanguageId.French,
      Text: 'Aucun kiosque sélectionné'
    }]
  },{
    Name: 'NoGenieResidents',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'You have no Genie residents'
    },{
      LanguageId: LanguageId.French,
      Text: 'Vous n\'avez aucun résident Genie'
    }]
  },{
    Name: 'NoGenieKiosks',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'You have no Genie kiosks'
    },{
      LanguageId: LanguageId.French,
      Text: 'Vous n\'avez aucun kiosque Genie'
    }]
  },{
    Name: 'NoAbbyResidents',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'You have no Abby residents'
    },{
      LanguageId: LanguageId.French,
      Text: 'Vous n\'avez aucun résident Abby'
    }]
  },{
    Name: 'NoUsers',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'No users found'
    },{
      LanguageId: LanguageId.French,
      Text: 'Aucun utilisateur trouvé'
    }]
  },{
    Name: 'NoOrganizations',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'No organizations found'
    },{
      LanguageId: LanguageId.French,
      Text: 'Aucune organisation trouvée'
    }]
  },{
    Name: 'NoProfiles',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'No profiles found'
    },{
      LanguageId: LanguageId.French,
      Text: 'Aucun profil trouvé'
    }]
  },{
    Name: 'NoDomains',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'No facilities found'
    },{
      LanguageId: LanguageId.French,
      Text: 'Aucune installation trouvée'
    }]
  },{
    Name: 'NoDomain',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '(No Domain)'
    },{
      LanguageId: LanguageId.French,
      Text: '(Aucune domaine)'
    }]
  },{
    Name: 'SelectDomain',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Select domain'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sélectionner domaine'
    }]
  },{
    Name: 'NoFacilities',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'No facilities found'
    },{
      LanguageId: LanguageId.French,
      Text: 'Aucune installation trouvée'
    }]
  },{
    Name: 'NoFacility',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '(No Facility)'
    },{
      LanguageId: LanguageId.French,
      Text: '(Aucune installation)'
    }]
  },{
    Name: 'SelectFacility',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Select facility'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sélectionner installation'
    }]
  },{
    Name: 'NoKiosks',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'No kiosks found'
    },{
      LanguageId: LanguageId.French,
      Text: 'Aucun kiosque trouvé'
    }]
  },{
    Name: 'NoKiosk',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '(No Kiosk)'
    },{
      LanguageId: LanguageId.French,
      Text: '(Aucun kiosque)'
    }]
  },{
    Name: 'SelectKiosk',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Select kiosk'
    },{
      LanguageId: LanguageId.French,
      Text: 'Sélectionner kiosque'
    }]
  },{
    Name: 'NoResidents',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'No residents found'
    },{
      LanguageId: LanguageId.French,
      Text: 'Aucun résidents trouvé'
    }]
  },{
    Name: 'NoKioskEmails',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'No GENIEGRAMs found'
    },{
      LanguageId: LanguageId.French,
      Text: 'Aucun GENIEGRAMs trouvé'
    }]
  },{
    Name: 'CannotUploadFile',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'The file <i>{0}</i> cannot be uploaded.<br/><br/>'
    },{
      LanguageId: LanguageId.French,
      Text: 'Impossible de télécharger le fichier <i>{0}</i>.<br/><br/>'
    }]
  },{
    Name: 'MustNotExceed',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'must not exceed'
    },{
      LanguageId: LanguageId.French,
      Text: 'ne doit pas dépasser'
    }]
  },{
    Name: 'SelectValidFiles',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Please select valid {0} files.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Veuillez sélectionner des fichiers {0} valides'
    }]
  },{
    Name: 'OnlyMp3Supported',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Only <b>mp3</b> audio files are supported at this time.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Ce format vidéo n’est pas pris en charge pour le moment.'
    }]
  },{
    Name: 'ResolutionTooLow',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '<b>Image resolution too low.</b>  Must be a minimum of 400 x 400 pixels.</br>'
    },{
      LanguageId: LanguageId.French,
      Text: '<b>Résolution d\'image trop faible.</b> Doit être d\'au moins 400 x 400 pixels.</br>'
    }]
  },{
    Name: 'ImageSizeIsOnly',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'This image is only'
    },{
      LanguageId: LanguageId.French,
      Text: 'Cette image ne compte que'
    }]
  },{
    Name: 'Pixels',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'pixels'
    },{
      LanguageId: LanguageId.French,
      Text: 'pixels'
    }]
  },{
    Name: 'AmbientStandardDescription',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Standard rotation and viewing time.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Rotation standard et durée de visionnement.'
    }]
  },{
    Name: 'AmbientAnnoucementDescription',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'More frequent rotation and extended viewing time.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Rotation plus fréquente et durée de visionnement prolongée.'
    }]
  },{
    Name: 'PlaylistInstruction',
    Items: [{
      LanguageId: LanguageId.English,
      Text: `<div>You can add media into {0} <i>{1}</i> by clicking the <b>ADD CONTENT</b> button.</div>
      <div>The options <b>Audio</b>, <b>Image</b> and <b>Video</b> allow you to upload from your computer.</div>
      <div>You can also pick from your <b>Master Library</b> of previously uploaded content.</div>
      <div>All newly uploaded content gets stored in your <b>Master Library</b> and can be <b>shared</b> among other {2}.</div>`
    },{
      LanguageId: LanguageId.French,
      Text: `<div>Vous pouvez ajouter du contenu médiadique dans {0} <i>{1}</i> en cliquant sur le bouton <b>AJOUTER DU CONTENU</b>.</div>
      <div>Les options <b>Audio</b>, <b>Image</b> et <b>Vidéo</b> vous permettent de télécharger depuis votre ordinateur.</div>
      <div>Vous pouvez également faire un choix dans <b>Bibliothèque principale</b> de contenu téléchargé antérieurement.</div>
      <div>Tout le contenu nouvellement téléchargé est stocké dans votre <b>Bibliothèque principale</b> et peut être <b>partagé</b> entre de {2}.</div>`
    }]
  },{
    Name: 'Finalizing',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Finalizing...'
    },{
      LanguageId: LanguageId.French,
      Text: 'Finalisation...'
    }]
  },{
    Name: 'UploadingXFiles',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Uploading {0} file(s)...'
    },{
      LanguageId: LanguageId.French,
      Text: 'Téléchargement de {0} fichier(s)...'
    }]
  },{
    Name: 'SendingMessage',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Sending message...'
    },{
      LanguageId: LanguageId.French,
      Text: 'Envoi du message...'
    }]
  },{
    Name: 'SendingEmail',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Sending email...'
    },{
      LanguageId: LanguageId.French,
      Text: 'Envoi d\'e-mail...'
    }]
  },{
    Name: 'PlaylistMissingMedia',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Playlist contains no media'
    },{
      LanguageId: LanguageId.French,
      Text: 'La playlist ne contient aucun élément média.'
    }]
  },{
    Name: 'AmbientStandardHint',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Standard rotation and viewing time.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Rotation standard et durée de visionnement.'
    }]
  },{
    Name: 'AmbientAnnouncementHint',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'More frequent rotation and extended viewing time.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Rotation plus fréquente et durée de visionnement prolongée.'
    }]
  },{
    Name: 'AbbySubscriptionAccessDenied',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'The subscription level for this kiosk does not provide access to kiosk management services.</br></br>' +
      'Please upgrade to a higher subscription plan.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le niveau d\'abonnement pour ce kiosque ne donne pas accès aux services de gestion de kiosque.</br></br>' +
      'Veuillez passer à un plan d\'abonnement supérieur.'
    }]
  },{
    Name: 'DeleteGenieResidentWarning',
    Items: [{
      LanguageId: LanguageId.English,
      Text: `Are you sure you wish to delete this resident?</br></br><b>{0}</b></br></br><p>All their messages, albums and media will be <b>permanently</b> deleted.</p>`
    },{
      LanguageId: LanguageId.French,
      Text: 'Voulez-vous vraiment supprimer ce résident?</br></br><b>{0}</b></br></br><p>Tous ses messages, albums et médias seront <b >définitivement</b> supprimés.'
    }]
  },{
    Name: 'DeleteAbbyResidentWarning',
    Items: [{
      LanguageId: LanguageId.English,
      Text: `Are you sure you wish to delete this resident?</br></br><b>{0}</b></br></br><p>All their personal playlist media will be <b>permanently</b> deleted.</p>`
    },{
      LanguageId: LanguageId.French,
      Text: 'Voulez-vous vraiment supprimer ce résident?</br></br><b>{0}</b></br></br><p>Tous les médias de sa playlist personnelle seront <b>permanents</b> supprimé.</p>'
    }]
  },{
    Name: 'NoChartItemsFound',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'No {0} were found for <i>{1}</i>'
    },{
      LanguageId: LanguageId.French,
      Text: 'Aucun {0} n\'a été trouvé pour <i>{1}</i>'
    }]
  },{
    Name: 'NoMemoryAlbums',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '{0} has no Memory albums.'
    },{
      LanguageId: LanguageId.French,
      Text: '{0} n\'a pas d\'albums souvenirs.'
    }]
  },{
    Name: 'NoMemoryAlbumContent',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'The memory album <i>{0}</i> contains no content.'
    },{
      LanguageId: LanguageId.French,
      Text: 'L\'album souvenir <i>{0}</i> ne contient aucun contenu.'
    }]
  },{
    Name: 'NoMessagesIn',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '{0} has no messages in for the selected time period.'
    },{
      LanguageId: LanguageId.French,
      Text: '{0} n\'a pas de messages entrants pour la période sélectionnée.'
    }]
  },{
    Name: 'NoMessagesOut',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '{0} has no messages out for the selected time period.'
    },{
      LanguageId: LanguageId.French,
      Text: '{0} n\'a pas de messages sortants pour la période sélectionnée.'
    }]
  },{
    Name: 'UserDiscoveredAndConnected',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Success!</br></br>An existing user with the email <b>{0}</b> was discovered and is now connected with <i>{1}</i>.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Succès!</br></br>Un utilisateur existant avec courriel <b>{0}</b> a été découvert et est maintenant branché à <i>{1}</i>.'
    }]
  },{
    Name: 'UserDiscoveredAndKioskAssigned',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Success!</br></br>An existing user with the email <b>{0}</b> was discovered and is now a manager of this kiosk.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Succès!</br></br>Un utilisateur existant avec le courriel <b>{0}</b> a été découvert et est maintenant un gestionnaire de ce kiosque.'
    }]
  },{
    Name: 'MessageSuccessfullySent',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Your message was successfully sent!'
    },{
      LanguageId: LanguageId.French,
      Text: 'Votre message a bien été envoyé!'
    }]
  },{
    Name: 'BrowserBackButtonWarning',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Use of the browser\'s back button causes <b>unpredictable behaviour</b>.</br></br>Instead please use the <b>back arrow button</b> provided at the top left of every screen.'
    },{
      LanguageId: LanguageId.French,
      Text: 'L\'utilisation du bouton de retour du navigateur cause des <b>comportements imprévisibles</b>.</br></br>Au lieu, veuillez utiliser la <b>flèche de retour</b> figurant au coin supérieur de chaque écran.'
    }]
  },{
    Name: 'RoleFFInfoText1',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Message their Resident using the AMBIENT CONNECT mobile app'
    },{
      LanguageId: LanguageId.French,
      Text: 'Envoyez un message à leur résident à l\'aide de l\'application mobile AMBIENT CONNECT'
    }]
  },{
    Name: 'RoleFFInfoText2',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Access AMBIENT ACCESS Admin site to create Memory Albums for their Resident'
    },{
      LanguageId: LanguageId.French,
      Text: 'Accéder au site d\'administration AMBIENT ACCESS pour créer des albums de mémoire pour leur résident'
    }]
  },{
    Name: 'RoleFFInfoText3',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Manage and Monitor their Resident\'s message content'
    },{
      LanguageId: LanguageId.French,
      Text: 'Gérer et surveiller le contenu des messages de leur résident'
    }]
  },{
    Name: 'RoleFFInfoText4',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Create other Virtual Visitor Contact(s) for their Resident'
    },{
      LanguageId: LanguageId.French,
      Text: 'Créer d\'autres contacts visiteurs virtuels pour leur résident'
    }]
  },{
    Name: 'RoleVVInfoText',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Message their Resident using the AMBIENT CONNECT mobile app'
    },{
      LanguageId: LanguageId.French,
      Text: 'Envoyez un message à leur résident à l\'aide de l\'application mobile AMBIENT CONNECT'
    }]
  },{
    Name: 'VideoBeingProcessedText',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'This video is currently being processed and will be available tomorrow.'
    },{
      LanguageId: LanguageId.French,
      Text: 'Cette vidéo est en cours de traitement et sera disponible demain.'
    }]
  },{
    Name: 'FileTypeNotAccepted',
    Items: [{
      LanguageId: LanguageId.English,
      Text: '{0} files are not accepted at this time.'
    },{
      LanguageId: LanguageId.French,
      Text: 'les fichiers {0} ne sont pas acceptés pour le moment.'
    }]
  }]
},{

  // menu items
  Type: 'MenuItem',
  Items: [{
    Name: 'UploadAudio',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Upload Audio'
    },{
      LanguageId: LanguageId.French,
      Text: 'Télécharger Audio'
    }]
  },{
    Name: 'UploadImages',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Upload Images'
    },{
      LanguageId: LanguageId.French,
      Text: 'Télécharger des images'
    }]
  },{
    Name: 'UploadVideos',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Upload Videos'
    },{
      LanguageId: LanguageId.French,
      Text: 'Télécharger des vidéos'
    }]
  },{
    Name: 'PickFromLibrary',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Pick From Library'
    },{
      LanguageId: LanguageId.French,
      Text: 'Choisir dans la bibliothèque'
    }]
  },{
    Name: 'All',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'All'
    },{
      LanguageId: LanguageId.French,
      Text: 'Tout'
    }]
  },{
    Name: 'Audio',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Audio'
    },{
      LanguageId: LanguageId.French,
      Text: 'Audio'
    }]
  },{
    Name: 'Image',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Image'
    },{
      LanguageId: LanguageId.French,
      Text: 'Image'
    }]
  },{
    Name: 'Video',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Video'
    },{
      LanguageId: LanguageId.French,
      Text: 'Vidéo'
    }]
  },{
    Name: 'FromComputer',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'From Your Computer'
    },{
      LanguageId: LanguageId.French,
      Text: 'De votre ordinateur'
    }]
  },{
    Name: 'FromSharedLibrary',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'From Shared Library'
    },{
      LanguageId: LanguageId.French,
      Text: 'De la bibliothèque partagée'
    }]
  },{
    Name: 'Text',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Text'
    },{
      LanguageId: LanguageId.French,
      Text: 'Texte'
    }]
  },{
    Name: 'EditProfile',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Edit Profile'
    },{
      LanguageId: LanguageId.French,
      Text: 'Modifier le profil'
    }]
  },{
    Name: 'ChangePassword',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Change Password'
    },{
      LanguageId: LanguageId.French,
      Text: 'Changer le mot de passe'
    }]
  },{
    Name: 'SignOut',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Sign Out'
    },{
      LanguageId: LanguageId.French,
      Text: 'Déconnexion'
    }]
  },{
    Name: 'WeekToDate',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Week To Date'
    },{
      LanguageId: LanguageId.French,
      Text: 'La semaine dernière jusqu\'à maintenant'
    }]
  },{
    Name: 'MonthToDate',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Month To Date'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le mois dernier jusqu\'à maintenant'
    }]
  },{
    Name: 'LastMonth',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Last Month'
    },{
      LanguageId: LanguageId.French,
      Text: 'Le mois dernier'
    }]
  },{
    Name: 'YearToDate',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Year To Date'
    },{
      LanguageId: LanguageId.French,
      Text: 'L\'année à ce jour'
    }]
  },{
    Name: 'LastYear',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Last Year'
    },{
      LanguageId: LanguageId.French,
      Text: 'L\'an dernier'
    }]
  }]
},{

  // breadcrumbs
  Type: 'Breadcrumb',
  Items: [{
    Name: 'Home',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Home'
    },{
      LanguageId: LanguageId.French,
      Text: 'Accueil'
    }]
  },{
    Name: 'KioskDashboard',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Kiosk Dashboard'
    },{
      LanguageId: LanguageId.French,
      Text: 'Tableau de bord du kiosque'
    }]
  },{
    Name: 'ResidentDashboard',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Resident Dashboard'
    },{
      LanguageId: LanguageId.French,
      Text: 'Tableau de bord du résident'
    }]
  },{
    Name: 'Users',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Users'
    },{
      LanguageId: LanguageId.French,
      Text: 'Utilisateurs'
    }]
  },{
    Name: 'MemoryAlbums',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Memory Albums'
    },{
      LanguageId: LanguageId.French,
      Text: 'Albums souvenir'
    }]
  },{
    Name: 'CommunityPlaylists',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Community Playlists'
    },{
      LanguageId: LanguageId.French,
      Text: 'Playlists publiques'
    }]
  },{
    Name: 'KioskLibrary',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Kiosk Library'
    },{
      LanguageId: LanguageId.French,
      Text: 'Bibliothèque de kiosque'
    }]
  },{
    Name: 'ResidentLibrary',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Resident Library'
    },{
      LanguageId: LanguageId.French,
      Text: 'Bibliothèque de résident'
    }]
  },{
    Name: 'KioskEmails',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'GENIEGRAMs'
    },{
      LanguageId: LanguageId.French,
      Text: 'GENIEGRAMs'
    }]
  },{
    Name: 'ResidentMetrics',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Resident Metrics'
    },{
      LanguageId: LanguageId.French,
      Text: 'Métrologie des résidents'
    }]
  },{
    Name: 'KioskManagers',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Kiosks Managers'
    },{
      LanguageId: LanguageId.French,
      Text: 'Gestionnaires de kiosque'
    }]
  },{
    Name: 'ResidentContacts',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Resident Contacts'
    },{
      LanguageId: LanguageId.French,
      Text: 'Contacts résidents'
    }]
  },{
    Name: 'ResidentPlaylists',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Resident Playlists'
    },{
      LanguageId: LanguageId.French,
      Text: 'Playlists du résident'
    }]
  },{
    Name: 'PlatformParticipants',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Platform Participants'
    },{
      LanguageId: LanguageId.French,
      Text: 'Participants de la plateforme'
    }]
  },{
    Name: 'Facilitators',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Facilitators'
    },{
      LanguageId: LanguageId.French,
      Text: 'Facilitateurs'
    }]
  },{
    Name: 'KioskPlaylists',
    Items: [{
      LanguageId: LanguageId.English,
      Text: 'Community Playlists'
    },{
      LanguageId: LanguageId.French,
      Text: 'Playlists publiques'
    }]
  }]
}]